import {useState} from "react";

const useForceUpdate = (): any => {
  /* eslint-disable */
  const [value, setValue] = useState(0);
  /* eslint-enable */
  return () => setValue(value => value + 1);
};

export default useForceUpdate;